import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bespoke',
  templateUrl: './bespoke.component.html',
  styleUrls: ['./bespoke.component.css']
})
export class BespokeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
